import { DashboardFilters, DateFilterRangeType, DateFilters } from '../redux/config/filters-api';
import { HierarchyFilterValues } from '../shared/Hierarchy';

type GetDashboardFiltersParams = {
  dateFilterRangeType?: DateFilterRangeType;
  fromDate?: string;
  toDate?: string;
  hierarchyValues?: HierarchyFilterValues;
  showArchived?: boolean;
};

export function getDashboardFiltersCombination({
  dateFilterRangeType,
  fromDate,
  toDate,
  hierarchyValues,
  showArchived,
}: GetDashboardFiltersParams): DashboardFilters {
  const hasHierarchyFilters = hierarchyValues && Object.keys(hierarchyValues).length > 0;

  const dateFiltersForView: DateFilters =
    dateFilterRangeType && dateFilterRangeType !== 'CUSTOM_FILTER_VALUE'
      ? { dateFilterRangeType }
      : { fromDate, toDate };

  return {
    ...(hasHierarchyFilters && {
      hierarchyFilters: {
        hierarchyValues,
        showArchived,
      },
    }),
    dateFiltersForView,
  };
}
